import useAct from 'Workflows/hooks/useAct'
import ServerWaitButton from 'Shared/components/ServerWaitButton'
import Button from 'Shared/components/Button'
import BackLink from 'Shared/components/BackLink'
import './TopBar.scoped.scss'

export default function Topbar() {
  const act = useAct()
  const { id, name, state, openingTime, closingTime, enforceSubscriptions, organisationName } = useSel(s => s.builder.workflow)
  const backLink = `/admin/workflows/${id}/overview`

  const [editingHours, setEditingHours] = useState(false)
  const [newOpeningTime, setNewOpeningTime] = useState('')
  const [newClosingTime, setNewClosingTime] = useState('')
  const [editingSubscriptions, setEditingSubscriptions] = useState(false)
  const [newEnforceSubscriptions, setNewEnforceSubscriptions] = useState(false)

  useEffect(() => {
    setNewOpeningTime(openingTime || '')
    setNewClosingTime(closingTime || '')
  }, [openingTime, closingTime])

  useEffect(() => {
    setNewEnforceSubscriptions(enforceSubscriptions || false)
  }, [enforceSubscriptions])

  function saveRunningHours() {
    act.builder.updateRunningHours({
      openingTime: newOpeningTime,
      closingTime: newClosingTime
    }).then(() => {
      setEditingHours(false)
    })
  }

  function saveEnforceSubscriptions() {
    act.builder.updateWorkflow({
      enforce_subscriptions: newEnforceSubscriptions
    }).then(() => {
      setEditingSubscriptions(false)
    })
  }

  function resume() {
    return act.local.openModal({ kind: 'resumeConfirm' })
  }

  function pause() {
    return act.builder.pause()
  }

  return <div className='top-bar'>
    <div className='title'>
      <div className='name'>
        <BackLink href={backLink} />
        <h2>{ name }</h2>
      </div>
      <div className='settings'>
        <div className='setting-pill'>
          <SvgIconsCalendar width={14} height={14} />
          {editingHours ? (
            <span className='align-center gap-10'>
              <input
                type='time'
                value={newOpeningTime}
                onChange={(e) => setNewOpeningTime(e.target.value)}
              />
              <span>to</span>
              <input
                type='time'
                value={newClosingTime}
                onChange={(e) => setNewClosingTime(e.target.value)}
              />
              <a className='link' onClick={saveRunningHours}>Save</a>
              <a className='link dark-grey' onClick={() => setEditingHours(false)}>Cancel</a>
            </span>
          ) : (
            <>
              <span className='dark-grey'>Hours</span>
              <span>{openingTime && closingTime ? `${openingTime} - ${closingTime}` : 'Not set'}</span>
              <a className='link dark-grey' onClick={() => setEditingHours(true)}>Edit</a>
            </>
          )}
        </div>
        <div className='setting-pill'>
          <SvgIconsMail width={14} height={14} />
          {editingSubscriptions ? (
            <span className='align-center gap-10'>
              <label className='align-center'><input type='radio' name='enforce_subscriptions' checked={newEnforceSubscriptions === true} onChange={() => setNewEnforceSubscriptions(true)} /> Enforce</label>
              <label className='align-center'><input type='radio' name='enforce_subscriptions' checked={newEnforceSubscriptions === false} onChange={() => setNewEnforceSubscriptions(false)} /> Do not enforce</label>
              <a className='link' onClick={saveEnforceSubscriptions}>Save</a>
              <a className='link dark-grey' onClick={() => setEditingSubscriptions(false)}>Cancel</a>
            </span>
          ) : (
            <>
              <span className='dark-grey'>Subscriptions</span>
              <span>
                {enforceSubscriptions ? 'Enforced' : 'Not enforced'}
                {organisationName && <span className='dark-grey'> ({organisationName})</span>}
              </span>
              <a className='link dark-grey' onClick={() => setEditingSubscriptions(true)}>Edit</a>
            </>
          )}
        </div>
      </div>
      <div className='filters'>
        <a className='link dark-grey' onClick={act.local.editEntryRules}>Edit entry Rules</a>
        <div className='ellipsis'></div>
        <a className='link dark-grey' onClick={act.local.editExitRules}>Edit exit Rules</a>
      </div>
    </div>
    <div className='buttons'>
      { state === 'draft' && <Button primary onClick={resume}>Launch</Button> }
      { state === 'paused' && <Button primary onClick={resume}>Resume</Button> }
      { state === 'running' && <ServerWaitButton secondary onClick={pause}>Pause</ServerWaitButton> }
    </div>
  </div>
}
